module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayOrganization === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayOrganization) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-industry fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.profileData.managed_organizations[_vm.organizationIndex].organizationName))])]), _vm._v(" "), (_vm.flagDisplayOrganization) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.organizationIsLoading) ? _c('spinner') : _c('div', [(_vm.flagDisplayIntegratorPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.labelTitleIntegratorTools[_vm.actualLanguage]))]), _vm._v(" "), (_vm.organizationModel.integrator_options.activationFlag) ? _c('button', {
    staticClass: "btn btn-success align-right push",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleIntegratorPanel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.labelButtonCloseIntegratorPanel[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), _c('integrator-tab-menu', {
    attrs: {
      "organization": _vm.organizationModel
    }
  })], 1)]) : _vm._e(), _vm._v(" "), ((_vm.flagDisplayIntegratorPanel == false) && (_vm.planTransactionData.transactionStatusCode === '000')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "font-w400"
  }, [_vm._v("ID:" + _vm._s(_vm.organizationModel.organizationId.substring(5, 30)))])]), _vm._v(" "), (_vm.organizationModel.integrator_options.activationFlag) ? _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleIntegratorPanel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.labelButtonOpenIntegratorPanel[_vm.actualLanguage]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxOrganizationName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.name),
      expression: "organizationModel.organizationInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxAdress[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.address),
      expression: "organizationModel.organizationInfo.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxCity[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.city),
      expression: "organizationModel.organizationInfo.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Ville / City..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxProvince[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.province),
      expression: "organizationModel.organizationInfo.province"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Province / Province ..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "province", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxCountry[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.country),
      expression: "organizationModel.organizationInfo.country"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pays / Country ..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxPostalCode[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.postalCode),
      expression: "organizationModel.organizationInfo.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Code postal / Postal code..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxPhone[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.phoneNumber),
      expression: "organizationModel.organizationInfo.phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "555-555-5555"
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "phoneNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "h2 font-w300"
  }, [_vm._v(_vm._s(_vm.sectionLabelOrganizationManager[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonFirstname[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonLastname[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonEmail[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonPhone[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelDeleteManager[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.organizationModel.managers), function(contact, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "100px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.firstName),
        expression: "contact.firstName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Prénom/Firstname"
      },
      domProps: {
        "value": (contact.firstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "firstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "100px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.lastName),
        expression: "contact.lastName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (contact.lastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "lastName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.email),
        expression: "contact.email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Courriel/Email"
      },
      domProps: {
        "value": (contact.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.phoneNumber),
        expression: "contact.phoneNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Téléphone/Phone number"
      },
      domProps: {
        "value": (contact.phoneNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "phoneNumber", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Retirer/Remove"
      },
      on: {
        "click": function($event) {
          return _vm.confirmRemoveManager(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addManager()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddOrganizationManager[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 push-20"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveOrganizationModifications()
      }
    }
  }, [(_vm.organizationIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonSaveModifications[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), (_vm.organizationModel.subscription.subscriptionId != 'NONE') ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 push-20"
  }, [(_vm.flagUserAsAdministratorLicence) ? _c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMySubscription === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMySubscription()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMySubscription) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMySubscription()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h2 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMySubscription()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelSubscriptionLicense[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMySubscription) ? _c('div', {
    staticClass: "block-content"
  }, [_c('h2', {
    staticClass: "h1 font-w300 push"
  }, [_vm._v(_vm._s(_vm.organizationModel.subscription.data.organization_plan_description.planInfo.title[_vm.actualLanguage]))]), _vm._v(" "), (false) ? _c('h3', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.tileLabelConsumptionTitle[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-television fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.rights.rights.channelLimit.count) + "/" + _vm._s(_vm.organizationModel.rights.rights.channelLimit.max))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelDevice[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.rights.rights.emailMonthlyLimit.count) + "/" + _vm._s(_vm.organizationModel.rights.rights.emailMonthlyLimit.max))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelEmail[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-stack-exchange fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.rights.rights.smsMonthlyLimit.count) + "/" + _vm._s(_vm.organizationModel.rights.rights.smsMonthlyLimit.max))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelSMS[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.backendConsumption.totalCallsCount))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelCallsCount[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-download fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.backendConsumption.totalReadItems))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelItemsRead[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.backendConsumption.totalProcessTime))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelProcessTime[_vm.actualLanguage]))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicenceOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "h2 block-title"
  }, [_vm._v(_vm._s(_vm.organizationModel.subscription.data.organization_licence.title[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_vm._v("Licence ID:" + _vm._s(_vm.organizationModel.subscription.subscriptionId.substring(11, 30)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6 push"
  }, [_c('h3', {
    staticClass: "h2 align-right"
  }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(_vm.organizationModel.subscription.data.organization_licence.price) + " $")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.organizationModel.subscription.data.organization_licence.customizedOptions.length > 0) ? _c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.organizationModel.subscription.data.organization_licence.customizedOptions), function(licenceOption, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
      staticClass: "text-center"
    }, [_c('h6', {
      staticClass: "h6 font-w700 push-10"
    }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (licenceOption.value)
      },
      on: {
        "change": function($event) {
          return _vm.computeCost()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(licenceOption, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
      },
      on: {
        "change": [function($event) {
          var $$a = licenceOption.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(licenceOption, "value", $$c)
          }
        }, function($event) {
          return _vm.computeCost()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" Activation\n                                                            ")])]) : _vm._e()])
  }), 0)]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicence[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.displayUserLicenceSectionFLag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, _vm._l((_vm.organizationModel.subscription.data.organization_user_licences), function(userLicence, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "h3 block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayUserLicenceFlag(index)
        }
      }
    }, [_vm._v(_vm._s(userLicence.title[_vm.actualLanguage]) + " ID: " + _vm._s(userLicence.licenceId.substring(11, 30)))])]), _vm._v(" "), (_vm.displayUserLicenceFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-12 col-lg-12 "
    }, [_c('h3', {
      staticClass: "h3 align-right"
    }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(userLicence.price) + " $")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-lg-6 "
    }, [(userLicence.linkedProfile.email != 'NONE') ? _c('h3', {
      staticClass: "h3 align-left"
    }, [_vm._v(_vm._s(_vm.tableLicenceUser[_vm.actualLanguage]) + " : " + _vm._s(userLicence.linkedProfile.email))]) : _c('h3', {
      staticClass: "h3 align-left"
    }, [_vm._v("Disponible/Available")])]), _vm._v(" "), (userLicence.linkedProfile.email != 'NONE') ? _c('div', {
      staticClass: "col-sm-6 col-lg-6 align-right"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-right",
      attrs: {
        "type": "button",
        "title": "Retirer/Release"
      },
      on: {
        "click": function($event) {
          return _vm.releaseLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelRemoveLicence[_vm.actualLanguage]))])]) : _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-lg-6 "
    }, [_c('button', {
      staticClass: "btn btn-md btn-success align-right",
      attrs: {
        "type": "button",
        "title": "Allouer/Attribute"
      },
      on: {
        "click": function($event) {
          return _vm.attributeLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelAllocate[_vm.actualLanguage]))])])]), _vm._v(" "), (userLicence.linkedProfile.email == 'NONE' && index >= _vm.organizationModel.subscription.data.organization_plan_description.planInfo.includedLicence) ? _c('div', {
      staticClass: "col-sm-12 col-lg-12"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-right",
      attrs: {
        "type": "button",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelDeleteLicence[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [(userLicence.customizedOptions.length > 0) ? _c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((userLicence.customizedOptions), function(licenceOption, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
        staticClass: "text-center"
      }, [_c('h6', {
        staticClass: "h6 font-w700 push-10"
      }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        staticClass: "form-control text-center",
        attrs: {
          "placeholder": "Valeur/Value"
        },
        domProps: {
          "value": (licenceOption.value)
        },
        on: {
          "change": function($event) {
            return _vm.computeCost()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(licenceOption, "value", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
        staticClass: "text-center"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
        },
        on: {
          "change": [function($event) {
            var $$a = licenceOption.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(licenceOption, "value", $$c)
            }
          }, function($event) {
            return _vm.computeCost()
          }]
        }
      }), _vm._v(" "), _c('span'), _vm._v(" Activation\n                                                            ")])]) : _vm._e()])
    }), 0)])]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.organizationModel.subscription.data.organization_plan_description.planInfo.maximumLicenceCount > 1) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12 push"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button",
      "title": "Ajouter/Add"
    },
    on: {
      "click": function($event) {
        return _vm.addUserLicence()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelAddUserLicence[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveLicenceOptionsModifications()
      }
    }
  }, [(_vm.licenceOptionsIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.buttonSaveLicenceOptions[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "h2 font-w300"
  }, [_vm._v(_vm._s(_vm.sectionLabelSubscriptionFees[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-money fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.actualMensualityLabel[_vm.actualLanguage]) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.sumFinalCost) + "$")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v(_vm._s(_vm.actualmensualityDescripCol1[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.actualmensualityDescripCol2[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Somme des frais de base")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.sumBaseCost) + " $")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Rabais de volume")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("-" + _vm._s(_vm.sumRebate) + " $")])]), _vm._v(" "), (_vm.specialRebate > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.specialRebateString))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("-" + _vm._s(_vm.specialRebate) + " $")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Estimation des frais mensuel")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.sumFinalCost) + " $")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "h2 font-w300"
  }, [_vm._v(_vm._s(_vm.sectionLabelPaymentInfo[_vm.actualLanguage]))]), _vm._v(" "), _c('organization-payment-info', {
    attrs: {
      "organizationData": _vm.organizationModel
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.subscribeToAdminPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelModifyMyPackage[_vm.actualLanguage]))])])])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12 push-20"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.textMessageUserDoNotHaveLicenceToEditOrganization[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.organizationModel.subscription.subscriptionId === 'NONE') ? _c('div', [_c('h5', {
    staticClass: "push-10"
  }, [_vm._v(_vm._s(_vm.textMessageToAccessMenager[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.subscribeToAdminPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelSubcribeToPackage[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('organization-payment-history', {
    attrs: {
      "organizationData": _vm.organizationModel
    }
  })], 1), _vm._v(" "), (_vm.organizationModel.apiManagement.apiActivationFlag) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('organization-api-management', {
    attrs: {
      "organizationData": _vm.organizationModel
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '055' || _vm.planTransactionData.transactionStatusCode === '065' || _vm.planTransactionData.transactionStatusCode === '105') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])])]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleServicePlanOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('admin-plan-table')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.returnToMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelReturnToMyProfileBtn[_vm.actualLanguage]))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '999') ? _c('div', {
    staticClass: "row"
  }, [(_vm.planTransactionData.postAction === 'NewSubscription') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelSubscriptionRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.postAction === 'NewAdminSubscription') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelAdminSubscriptionRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.postAction === 'ModifyCreditCard') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelNewCreditCardRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.returnToMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelReturnToMyProfileBtn[_vm.actualLanguage]))])])])])]) : _vm._e()])], 1) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74045f52","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/OrganizationDisplay.vue
// module id = 1567
// module chunks = 4